import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule, DatePipe } from "@angular/common";
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { HeaderModule } from "../../header/header.module";
import { SidemenuModule } from "../../sidemenu/sidemenu.module";
import { FooterModule } from "../../footer/footer.module";
import { ChartsModule } from 'ng2-charts';
import { FlatpickrModule } from 'angularx-flatpickr';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';


import { DashboardComponent } from './components/dashboard/dashboard.component';
import { UserMngntComponent } from './components/user-mngnt/user-mngnt.component';
import { DashboardMngntComponent } from './components/dashboard-mngnt/dashboard-mngnt.component';
import { LoadInfoComponent } from './components/load-info/load-info.component';
import { DynamicChartComponent } from './components/dynamic-chart/dynamic-chart.component';
import { StationInventoryComponent } from './components/station-inventory/station-inventory.component';
import { SelectDropDownModule } from 'ngx-select-dropdown';
import { InventoryLoadsComponent } from './components/inventory-loads/inventory-loads.component';
import { TankChartsComponent } from './components/tank-charts/tank-charts.component';
import { NgxSliderModule } from "@angular-slider/ngx-slider";
import { InventoryLineChartComponent } from './components/inventory-line-chart/inventory-line-chart.component';
import { StationTankLevelsComponent } from './components/station-tank-levels/station-tank-levels.component';
import { TankCircleComponent } from './components/tank-circle/tank-circle.component';
import { InventoryTankLevelsComponent } from './components/inventory-tank-levels/inventory-tank-levels.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxMaterialTimepickerModule } from "ngx-material-timepicker";
import { DndDirective } from "../upload/dnd.directive";
import { TakeOrderComponent } from './components/dashboard-mngnt/take-order/take-order.component';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from "ng-pick-datetime";
import { AuthGuardService } from "src/app/auth-guard.service";
import { UploadModule } from "../upload/upload.module";
import { CeDatetimePickerComponent } from "../../ce-datetime-picker/ce-datetime-picker.component";
import { TankInventoryComponent } from './components/tank-inventory/tank-inventory.component';
import { PaperWorkComponent } from './components/paper-work/paper-work.component';

@NgModule({
  declarations: [DashboardComponent, UserMngntComponent, 
    DashboardMngntComponent, LoadInfoComponent, 
    DynamicChartComponent, StationInventoryComponent, 
    InventoryLoadsComponent, TankChartsComponent, InventoryLineChartComponent, 
    StationTankLevelsComponent, TankCircleComponent, InventoryTankLevelsComponent, DndDirective, 
    TakeOrderComponent, CeDatetimePickerComponent, TankInventoryComponent, PaperWorkComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    OwlDateTimeModule, 
    OwlNativeDateTimeModule,
    NgbModule,
    HeaderModule,
    SidemenuModule,
    FooterModule,
    ChartsModule,
    NgbModalModule,
    SelectDropDownModule,
    NgxSliderModule,
    NgSelectModule,
    FlatpickrModule.forRoot(),
    NgxMaterialTimepickerModule,
    UploadModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory
    }),
    RouterModule.forChild([

      {
        path: "",
        component: DashboardMngntComponent,
        canActivate: [AuthGuardService]
      },
  
      {
        path: 'user-mngnt',
        component: UserMngntComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: "graph",
        component: DynamicChartComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'dashboard-mngnt',
        component: DashboardMngntComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'station-inventory',
        component: StationInventoryComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'inventory-tank-levels',
        component: InventoryTankLevelsComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'take-order',
        component: TakeOrderComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'tank-inventory',
        component: TankInventoryComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'paper-work',
        component: PaperWorkComponent,
        canActivate: [AuthGuardService]
      }
    ])
  ],
  providers:[DatePipe],
})
export class DashboardModule { }
